import React from "react";
import PropTypes from "prop-types";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import ArrowLeftRoundedIcon from "@mui/icons-material/ArrowLeftRounded";
import ArrowRightRoundedIcon from "@mui/icons-material/ArrowRightRounded";

export function Caret({ direction, ...rest }) {
    switch (direction) {
        case "up":
            return <ArrowDropUpRoundedIcon {...rest} />;
        case "down":
            return <ArrowDropDownRoundedIcon {...rest} />;
        case "left":
            return <ArrowLeftRoundedIcon {...rest} />;
        case "right":
            return <ArrowRightRoundedIcon {...rest} />;
    }
}

Caret.propTypes = {
    direction: PropTypes.string
};
